import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, isValid } from 'date-fns';
import config from '../../../config';

const PerformanceNew = ({ selectedDate }) => {
  const [data, setData] = useState({ 일: { 제: {}, 원: {} }, 월: { 제: {}, 원: {} } });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // 로컬 로딩 상태

  const dateObj = new Date(selectedDate);
  const formattedDate = isValid(dateObj) ? format(dateObj, 'yyyyMMdd') : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!formattedDate) return;

      setLoading(true); // 로컬 로딩 상태 시작

      try {
        const response = await axios.post(
          `${config.apiUrl}/stockSel.do`,
          { stdate: formattedDate },
          { headers: { 'Content-Type': 'application/json' } },
        );

        const apiData = response.data;
        const transformedData = transformData(apiData);
        setData(transformedData);
        setError(null); // 에러 초기화
      } catch (err) {
        console.error('데이터를 가져오는 중 에러 발생:', err);
        setError('데이터를 가져오는 중 문제가 발생했습니다.');
      } finally {
        setLoading(false); // 로딩 상태 종료
      }
    };

    fetchData();
  }, [formattedDate]);

  const formatNumber = num => (typeof num === 'number' ? num.toLocaleString() : num);

  const transformData = apiData => {
    const machines = {
      일: { 제: { 목표: '', 실적: '', '달성율(%)': '', 재고: '' }, 원: { 목표: '', 실적: '', '달성율(%)': '', 재고: '' } },
      월: { 제: { 목표: '', 실적: '', '달성율(%)': '', 재고: '' }, 원: { 목표: '', 실적: '', '달성율(%)': '', 재고: '' } },
    };

    if (apiData && Array.isArray(apiData.resultData)) {
      apiData.resultData.forEach(entry => {
        const productKeys = {
          목표: ['DPLATON', 'PLNTON'],
          실적: ['PANTON', 'SUMPAN'],
          '달성율(%)': ['DDALSE', 'DALSEO'],
          재고: ['INVQNT', 'INVQNT'],
        };

        const materialKeys = {
          목표: ['DAYGOL', 'MONGOL'],
          실적: ['DAYSUM', 'RAWSUM'],
          '달성율(%)': ['DDALSE', 'DALSEO'],
          재고: ['RAWJEG', 'RAWJEG'],
        };

        Object.keys(productKeys).forEach(category => {
          const productCategoryKeys = productKeys[category];
          
          if (productCategoryKeys) {
            if (entry[productCategoryKeys[0]] !== undefined) {
              let value = (typeof entry[productCategoryKeys[0]] === 'string' && entry[productCategoryKeys[0]].includes('ton'))
                ? entry[productCategoryKeys[0]].replace(/[^\d]/g, '')
                : entry[productCategoryKeys[0]];

              if (category === '달성율(%)') {
                value = value.toString().substring(0, value.toString().length - 2);
              }

              machines.일.제[category] = formatNumber(value);
            }
            if (entry[productCategoryKeys[1]] !== undefined) {
              let value = (typeof entry[productCategoryKeys[1]] === 'string' && entry[productCategoryKeys[1]].includes('ton'))
                ? entry[productCategoryKeys[1]].replace(/[^\d]/g, '')
                : entry[productCategoryKeys[1]];

              if (category === '달성율(%)') {
                value = value.toString().substring(0, value.toString().length - 2);
              }

              machines.월.제[category] = formatNumber(value);
            }
          }
        });

        Object.keys(materialKeys).forEach(category => {
          const materialCategoryKeys = materialKeys[category];

          if (materialCategoryKeys) {
            if (entry[materialCategoryKeys[0]] !== undefined) {
              machines.일.원[category] = formatNumber(
                parseFloat(entry[materialCategoryKeys[0]].toString().replace(/[^\d.]/g, ''))
              );
            }
            if (entry[materialCategoryKeys[1]] !== undefined) {
              machines.월.원[category] = formatNumber(
                parseFloat(entry[materialCategoryKeys[1]].toString().replace(/[^\d.]/g, ''))
              );
            }
          }
        });
      });
    }

    return machines;
  };

  const categories = ['목표', '실적', '달성율(%)', '재고'];

  return (
  <div className='relative mt-[4%]'>
    {loading && (
      <div className='absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center z-10'>
        <div className="text-white text-2xl font-bold">Loading...</div>
      </div>
    )}
    {error && <div className='text-red-600'>{error}</div>}
    <div className='w-[25%] change_2h page_center bg-blue-200 font-bold text-blue-600'>실적&재고</div>
    <div className='b2-box'>
      <div className='flex flex-row'>
        <div className='flex flex-col w-[50%] b2-r h-[100%]'>
          <div className='w-[100%] change_2h b2-b page_center'>구분</div>
          <div className='flex flex-col w-[100%]'>
            <div className='flex flex-row'>
              <div className='w-[50%] change_2h4 b2-r b2-b page_center font-bold'>제품(Ton)</div>
              <div className='flex flex-col w-[50%]'>
                {categories.map((category, index) => (
                  <div
                    key={index}
                    className={`w-[100%] change_2h ${category === '재고' ? 'border-black border-b-2' : 'b-g'} page_center`}
                  >
                    {category === '목표' ? (
                      <>
                        <div className='mx-2'>목</div>
                        <div className='mx-2'>표</div>
                      </>
                    ) : category === '실적' ? (
                      <>
                        <div className='mx-2'>실</div>
                        <div className='mx-2'>적</div>
                      </>
                    ) : category === '재고' ? (
                      <>
                        <div className='mx-2'>재</div>
                        <div className='mx-2'>고</div>
                      </>
                    ) : (
                      category
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className='flex flex-row'>
              <div className='w-[50%] change_2h4 b2-r page_center font-bold'>원료(Ton)</div>
              <div className='flex flex-col w-[50%]'>
                {categories.map((category, index) => (
                  <div key={index} className={`w-[100%] change_2h ${category === '재고' ? '' : 'b-g'} page_center`}>
                    {category === '목표' ? (
                      <>
                        <div className='mx-2'>목</div>
                        <div className='mx-2'>표</div>
                      </>
                    ) : category === '실적' ? (
                      <>
                        <div className='mx-2'>실</div>
                        <div className='mx-2'>적</div>
                      </>
                    ) : category === '재고' ? (
                      <>
                        <div className='mx-2'>재</div>
                        <div className='mx-2'>고</div>
                      </>
                    ) : (
                      category
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col w-[25%] b2-r h-[100%]'>
          <div className='w-[100%] change_2h b2-b page_center'>일</div>
          {categories.map((category, index) => (
            <div
              key={index}
              className={`w-[100%] change_2h r-center ${category === '재고' ? 'border-black border-b-2' : 'b-g'}`}
            >
              {data.일.제[category] || ''}
            </div>
          ))}
          {categories.map((category, index) => (
            <div key={index} className={`w-[100%] change_2h r-center ${category === '재고' ? '' : 'b-g'}`}>
              {data.일.원[category] || ''}
            </div>
          ))}
        </div>

        <div className='flex flex-col w-[25%] h-[100%]'>
          <div className='w-[100%] change_2h b2-b page_center'>월</div>
          {categories.map((category, index) => (
            <div
              key={index}
              className={`w-[100%] change_2h r-center ${category === '재고' ? 'border-black border-b-2' : 'b-g'} `}
            >
              {data.월.제[category] || ''}
            </div>
          ))}
          {categories.map((category, index) => (
            <div key={index} className={`w-[100%] change_2h r-center ${category === '재고' ? '' : 'b-g'}`}>
              {data.월.원[category] || ''}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>

  );
};

export default PerformanceNew;
